<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="despatchRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<DespatchUnBillReporttable :tableData="tableData" :total="total" @Export="Export"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</DespatchUnBillReporttable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import DespatchUnBillReporttable from './components/despatchUnBillReporttable.vue'
	import utils from '../../../common/utils'
	import {
		WMSReportDespatchUnBillReportList,
		WMSReportDespatchUnBillReportExport,
		InventoryClassList,
		ASNVoucherType,
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			DespatchUnBillReporttable,
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '医院名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						options: [

						],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '出库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
				],
				from: {
					CreateOrgName: "",
					DPDate1: "",
					DPDate2: "",
					CusName: "",
					Inventory: "",
					InvClass: "",
					VouCode: "",
					Batch: "",
				}
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			this.$refs.despatchRef[2].startTime = this.$utils.getFYearDate();
			//this.wMSReportDespatchUnBillReportList()
			this.inventoryClassList()
		},
		methods: {
			// 获取产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					try {
						this.formdata[5].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[5].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 列表
			async wMSReportDespatchUnBillReportList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					data,
					code,
					message
				} = await WMSReportDespatchUnBillReportList({
					CreateOrgName: this.from.CreateOrgName,
					DPDate1: this.from.DPDate1,
					DPDate2: this.from.DPDate2,
					CusName: this.from.CusName,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					VouCode: this.from.VouCode,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message.warning(message)
				}
				loading.close();
			},
			// 导出
			async wMSReportDespatchUnBillReportExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await WMSReportDespatchUnBillReportExport({
					CreateOrgName: this.from.CreateOrgName,
					DPDate1: this.from.DPDate1,
					DPDate2: this.from.DPDate2,
					CusName: this.from.CusName,
					Inventory: this.from.Inventory,
					InvClass: this.from.InvClass,
					VouCode: this.from.VouCode,
					Batch: this.from.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `销售出库未开票报表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.wMSReportDespatchUnBillReportExport()
			},
			// 清空
			reset() {
				this.$refs.despatchRef.map((item, index) => {
					if (index == 2) {
						item.startTime = ''
						item.endTime = ''
					} else {
						item.modelvalue = ''
					}
				})

			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.CreateOrgName = this.$refs.despatchRef[0].modelvalue
					this.from.CusName = this.$refs.despatchRef[1].modelvalue
					this.from.DPDate1 = this.$refs.despatchRef[2].startTime
					this.from.DPDate2 = this.$refs.despatchRef[2].endTime
					this.from.Inventory = this.$refs.despatchRef[3].modelvalue
					this.from.Batch = this.$refs.despatchRef[4].modelvalue
					this.from.InvClass = this.$refs.despatchRef[5].modelvalue ? this.$refs.despatchRef[5].modelvalue.join(
						',') : ''
					this.from.VouCode = this.$refs.despatchRef[6].modelvalue
					this.wMSReportDespatchUnBillReportList()
				} catch (error) {
					this.wMSReportDespatchUnBillReportList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wMSReportDespatchUnBillReportList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wMSReportDespatchUnBillReportList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 50px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 320px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>